import { render, staticRenderFns } from "./screenPhotobooth.vue?vue&type=template&id=1fc33bd6&"
import script from "./screenPhotobooth.vue?vue&type=script&lang=js&"
export * from "./screenPhotobooth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports